export enum GTM_CUSTOM_EVENT {
  COMPLETE_REGISTRATION = "GTM Complete Registrations",
  PURCHASE = "GTM Purchases",
  DIRECT_TO_PAY_PURCHASE = "GTM DirectPay",
  WEB_ACQ_PREPAYMENT_VIEW = "WebAcqPrepaymentView",
  WEB_ACQ_PREPAYMENT_SUCCESS = "WebAcqPrepaymentSuccess",
}
